import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Link } from "react-router-dom";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center px-6 grid-bg relative" data-testid="login-page">
      <div className="absolute inset-0 radial-glow pointer-events-none" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
        <div className="border border-white/10 glass p-8 sm:p-10">
          <img src="/logo-light.png" alt="Growing IT Solutions" className="h-9 w-auto mb-8" />
          <div className="flex items-center gap-2 mb-2">
            <Lock className="w-4 h-4 text-primary" />
            <h1 className="font-heading text-2xl font-semibold">Admin Login</h1>
          </div>
          <p className="text-sm text-slate-400 mb-7">Sign in to manage your content and leads.</p>

          {error && <div data-testid="login-error" className="mb-5 text-sm text-red-400 bg-red-500/10 border border-red-500/30 px-4 py-3">{error}</div>}

          <form onSubmit={submit} className="space-y-5">
            <label className="block">
              <span className="block text-xs uppercase tracking-wider text-slate-500 font-semibold mb-2">Email</span>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#05060A] border border-white/10 focus:border-primary outline-none text-white px-4 py-3 transition-colors" placeholder="admin email" />
            </label>
            <label className="block">
              <span className="block text-xs uppercase tracking-wider text-slate-500 font-semibold mb-2">Password</span>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#05060A] border border-white/10 focus:border-primary outline-none text-white px-4 py-3 transition-colors" placeholder="••••••••" />
            </label>
            <button data-testid="login-submit" type="submit" disabled={busy} className="w-full bg-primary hover:bg-primary/90 text-white font-semibold px-8 py-3.5 glow-blue transition-all disabled:opacity-60">
              {busy ? "Signing in..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
